module.exports = __webpack_public_path__ + "assets/img/qrcode-qw-c50cfd46.jpg";